export default __webpack_public_path__ + "images/a-application-complete-sign.svg";